<template>
  <PartsLayoutContainer>
    <section class="sec_footer-regular">
      <div class="home-title-area">
        <h2 class="home-title">定期コース特典</h2>
        <p class="home-subtitle">お得で便利な特典をご用意しています</p>
      </div>

      <!--
        5大特典は支給の1枚画像。第16便（2026-09-04）で支給が HTML から画像へ戻したのに合わせた
        （`docs/design-renewal/CORRECTIONS.md` V-27）。
      -->
      <div class="regular-box">
        <img
          src="/image/regular/regular-course001.png"
          class="pc-only"
          alt="お得で便利！定期コースの特典"
        />
        <img
          src="/image/regular/regular-course001_sp.png"
          class="sp-only"
          alt="お得で便利！定期コースの特典"
        />
      </div>

      <OrganismsSupportRegularFaq />
    </section>
  </PartsLayoutContainer>
</template>

<script setup lang="ts">
/**
 * 支給デザインの `sec_footer-regular`（定期コース特典）。サポート導線4コンテンツの1つ。
 * 単体では使わず `OrganismsSupport` から呼ぶ。
 *
 * **定期コースのよくあるご質問（`OrganismsSupportRegularFaq`）はこの section の中に入る。**
 * 支給デザインの入れ子どおりで、`.sec_footer-regular` の `max-width: 940px` を効かせるため。
 */
</script>
